import {ViewPersonalConfig} from "../../@type";
import {ViewType} from "../../../../gd/const/views/view-type";
import {PersonalViewLocation} from "../@types";
import {Feature} from "../../../../gd/access-control/feature-access/const";

export const MY_MEETINGS_CONFIG : ViewPersonalConfig= {
    type            : ViewType.MY_MEETINGS,
    name            : 'Meetings',
    icon            : 'i5-meeting',
    iconSvg         : 'isvg-view-meetings',
    url             : 'my-meetings',
    description     : 'All your meetings in one place',
    defaultLocation : PersonalViewLocation.HOME_MORE,
    feature         : Feature.MEETINGS
}
